import React, { Component } from 'react';
import PropTypes            from 'prop-types';
import { Form, Icon, Grid } from 'semantic-ui-react';

// -----------------------------------------------------
// Helpers
// -----------------------------------------------------

const draggingStyle = {
  userSelect: 'none',
  background: 'lightyellow'
};

const baseStyle = {
  transition: 'background 0.75s'
};

function getDraggableStyle(isDragging, draggableStyle) {
  const style = { ...draggableStyle, ...baseStyle };

  if(isDragging) {
    return { ...style, ...draggingStyle,  };
  }

  return style;
}

// -----------------------------------------------------
// Component Definition
// -----------------------------------------------------

class SequenceForm extends Component {
  constructor(props) {
    super(props);

    this.handleRemove  = this.handleRemove.bind(this);
  }

  render() {
    const { label,
            draggableProvided,
            draggableSnapshot } = this.props;

    const { dragHandleProps, draggableProps } = draggableProvided;


    const style = getDraggableStyle(
      draggableSnapshot.isDragging,
      draggableProps.style
    );

    return (
      <Grid.Row { ...draggableProps } style={ style }>
        <Grid.Column width={ 1 }>
          <Icon name='bars'
                size='large'
                { ...dragHandleProps }
                tabIndex='-1' />

        </Grid.Column>

        <Grid.Column width={ 12 }>
          <h5 { ...dragHandleProps } tabIndex='-1'>
            { label }
          </h5>

        </Grid.Column>

        <Grid.Column width={ 2 } textAlign='right'>

          <Form.Button    basic
                          color='red'
                          icon='remove'
                          size='mini'
                          type='button'
                          tabIndex='-1'
                          onClick={ this.handleRemove } />
        </Grid.Column>
      </Grid.Row>
    );
  }

  handleRemove(evt) {
    evt.preventDefault();
    const { index, onRemove } = this.props;
    onRemove(evt, { index });
  }
}

// -----------------------------------------------------
// PropTypes
// -----------------------------------------------------

SequenceForm.propTypes = {
  label:                  PropTypes.string,
  index:                  PropTypes.number.isRequired,
  onRemove:               PropTypes.func.isRequired,
  draggableProvided:      PropTypes.object.isRequired,
  draggableSnapshot:      PropTypes.object.isRequired
};

// -----------------------------------------------------
// Exports
// -----------------------------------------------------

export default SequenceForm;
